// extracted by css-extract-rspack-plugin
export default {"cls1":"BucketBadge-cls1_TgN","cls2":"BucketBadge-cls2_Wxv BucketBadge-cls1_TgN"};